<template>
  <modal 
    name="send-client-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'560px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        Send client to another broker
      </div>

      <a href="#"
        @click.prevent="$modal.hide('send-client-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body">
      <template v-if="step == 'search'">
        <div class="text-sm">
          Please type in the email of the broker you wish to send this client to
        </div>

        <div class="form-line">
          <input type="text" v-model="email" ref="email" class="input-standard" />
          <div v-if="emailError != null" class="text-red-600 mt-1 text-sm">{{ emailError }}</div>
        </div>

        <div class="mt-6">
          <SubmitButton2 :onClick="search" :loading="loading" label="Search" />
        </div>
      </template>

      <template v-if="step == 'broker-found'">
        <div class="text-sm">
          We have found the following broker based on the email 
          <span class="text-blue-600 font-semibold">{{ email }}</span>.
        </div>

        <div class="mt-2 bg-blue-100 p-4 rounded border border-blue-600">
          <div class="text-sm">{{ user.first_name }} {{ user.last_name }}</div>
          <div class="text-sm" v-if="user.email != null">{{ user.email }}</div>
          <div class="text-sm" v-if="broker.phone_mobile != null">{{ broker.phone_mobile }}</div>
          <div class="text-sm" v-if="broker.company != null">{{ broker.company }}</div>
        </div>

        <template v-if="broker.suspended">
          <div class="text-sm mt-4">
            We cannot send to this client because this broker is currently not subscribed to a paid plan. 
            Please contact them and ask them to upgrade their subscription.
          </div>
        </template>

        <template v-else>
          <div class="text-sm mt-4">
            By sending the client to this broker, the client will move from your list to this broker's list.
            We will notify the broker via email that the client has been moved and 
            a copy of the email will also be sent to your email.
          </div>
          
          <div class="mt-6">
            <SubmitButton2 :onClick="send" :loading="loading" label="Send the client to this broker" />
          </div>
        </template>
      </template>

      <template v-if="step == 'not-found'">
        <div class="text-base">
          We could not find a broker with email
          <span class="text-blue-600 font-semibold">{{ email }}</span>. Would you like to invite them to {{ getAppName }}?
        </div>

        <div class="mt-6 text-base">
          <SubmitButton2 :onClick="invite" :loading="loading" label="Invite this broker to Brokerpad!" :isFullWidth="true" />
        </div>

        <div class="mt-4 text-sm flex justify-center">
          <!-- Otherwise, you can invite them to register on Brokerpad 

          <router-link :to="{
            name : 'broker-referral',
            params : {
              brokerId : $store.state[$store.state.view + 'Module'].broker.id
            }
          }" tag="a"
          class="text-blue-600 underline">using your referral link</router-link>. -->
          <!-- Please check the email address you entered and  -->
          <a href="#" class="text-gray-500 hover:underline" @click.prevent="step = 'search'">Search again</a>
        </div>
      </template>
    </div>
  </modal>
</template>

<script>
  import validator      from "validator"
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'

  export default {

    components : {
      SubmitButton2
    },

    data() {
      return {
        client    : null,
        email     : null,
        loading   : false,
        emailError: null,
        broker    : null,
        step      : 'search'
      }
    },

    methods : {

      close() {
        this.$modal.hide('send-client-modal')
      },
      
      beforeOpen(event) {
        this.loading    = false
        this.client     = event.params.client
        this.user       = null
        this.email      = null
        this.broker     = null
        this.emailError = null
        this.step       = 'search'
      },

      opened(event) {
        this.$refs.email.focus()
      },

      search() {
        let valid       = true
        this.emailError = null

        if(this.email == null || !validator.isEmail(this.email)) {
          this.emailError = "Please type a valid email."
          valid = false
        }

        if(valid) {
          this.loading = true
          this.apiGet({
            email : this.email
          }, 'client-sender/search-broker', (res) => {
            this.loading = false

            if(res) {
              this.broker = res.broker
              this.user   = res.user
              this.step   = 'broker-found'
            }

            else {
              this.step   = 'not-found' 
            }
          })
        }
      },

      send() {
        this.loading = true
        this.apiPost({
          clientId: this.client.id,
          userId  : this.user.id,
          brokerId: this.broker.id
        }, 'client-sender/send-client-to-broker', (res) => {
          EventBus.$emit('fetch-clients')
          this.loading = false
          this.close()
          EventBus.$emit('notification-event', {
            type   : 'success',
            message: 'Client sent successfully.'
          })
        })
      },

      invite() {
        let user    = this.$store.state.user
        let broker  = this.$store.state[this.$store.state.view + 'Module'].broker

        this.loading = true
        let link     = this.getReferralLink(user, broker)
        this.apiPost({
          emails: [{
            email : this.email
          }],
          msg   : this.getDefaultReferralMessage(user, link),
          link  : link
        }, 'broker/send-referrals', (data) => {          
          this.loading = false
          this.close()
          EventBus.$emit('notification-event', {
            'type'   : 'success',
            'message': "Invite sent successfully."
          })
        })
      }
    }
  }
</script>